document.addEventListener( 'click', e => {

  // toggle menu primary
  if( e.target.matches( '.open-menu,.overlay' ) ) {
    document.body.classList.toggle( 'menu-open' )
  } else {

    // toggle submenu in menu primary
    const parentLi = e.target.closest( '.menu-item-has-children' )
    if( parentLi ) {
      const liOpen = document.querySelectorAll( '#menu-menu-primary .menu-item-has-children.open' )
      for( const li of liOpen ) {
        if( !li.isEqualNode( parentLi ) )
          li.classList.remove( 'open' )
      }
      parentLi.classList.toggle( 'open' )
    }

    // prevent click on a with "#" href
    if( e.target.matches( '#menu-menu-primary a[href="#"]' ) ) {
      e.preventDefault()
    }

  }

} )
